import layers from "./layers";
import overlays from "./overlays";
import store from "./store";
import products from "./products";


class LegendRenderController {
    constructor (view){
        this.view = view;

        this.view.bindPaintLegend(this.paintLegend.bind(this));

        store.on("overlay", this.view.updateBars.bind(this.view));
        store.on("usedLang", this.view.updateBars.bind(this.view));
        store.on("product", this.updateProductMessage.bind(this));
    }

    updateProductMessage(){
        const product = products[store.get("product")];
        if (product.copy && this.view.message) {
            this.view.message.innerText = product.copy;
            this.view.message.classList.add("visible");
        }
        else if (this.view.message){
            this.view.message.classList.remove("visible");
        }
    }


    paintLegend() {
        // const element = this.view.bars;

        const overlay = overlays[store.get("overlay")];

        const view= this.view;

        if (overlay.htmlLegend){
            this.view.regendLegendHTML(overlay.htmlLegend);
        }
        else if (overlay.legends) {
            let nlegend = 1; //, legends = this.legends;

            overlay.legends.forEach(function (layerName){

                const layer = layers[layerName];


                if (layer.m && layer.m.description) {
                    const metric = layer.l || layer.m;
                    const indexMetric = metric.description.indexOf(layer.m.metric) + 1;

                    layer.c.getColor();

                    view.renderLegend(layer.c.gradient,
                        layer.c.continuous,
                        nlegend,
                        metric.getLines().map(
                            function (line) {
                                return {value: line[0], text: line[indexMetric].toString()};
                            }
                        ),
                        layer.m.metric,
                        layer.getName());
                }

                nlegend++;

            });

        }
        else if ( overlay.m && overlay.m.description ) {

            const metric = overlay.l || overlay.m;
            const indexMetric = metric.description.indexOf(overlay.m.metric) + 1;

            // const indexMetric = overlay.m.description.indexOf(overlay.m.metric) + 1;

            overlay.c.getColor();

            view.renderLegend(overlay.c.gradient,
                overlay.c.continuous,
                1,
                metric.getLines().map(
                    function (line) {
                        return {value: line[0], text: line[indexMetric].toString()};
                    }
                ),
                overlay.m.metric,
                overlay.getName()
                )

            // this.m.renderLegend(this.c, element, this.l || this.m, this.getName());
        }
        // else
        //     element.innerHTML = "";

    }
}

export default LegendRenderController;
